export default [
  {
    key: 'Retailer Preference Breakdown',
    category: 'Retailers',
    value: {
      dimensions: ['cartName'],
      metrics: ['retailerDisplayed', 'retailerPreference', 'purchaseIntentClicks', 'retailerPurchaseIntentRate'],
      filters: [],
    },
  },
  {
    key: 'Performance Breakdown',
    category: 'Platforms',
    value: {
      dimensions: ['platformName', 'cartName', 'cityAmplitude', 'regionAmplitude'],
      metrics: ['retailerDisplayed', 'retailerPreference', 'purchaseIntentClicks', 'retailerPurchaseIntentRate'],
      filters: [],
    },
  },
  {
    key: 'Facebook/Instagram Placement Optimized Breakdown',
    category: 'Platforms',
    value: {
      dimensions: ['platformName', 'environment'],
      metrics: ['pageViews', 'purchaseIntentClicks', 'purchaseIntentRate', 'avgTimeSpent'],
      filters: [
        {
          key: 'platformName',
          operator: 'includes',
          value: ['FB/IG'],
        },
      ],
    },
  },
  {
    key: 'Campaign Breakdown',
    category: 'Campaigns',
    value: {
      dimensions: ['campaignName', 'campaignObjectiveType'],
      metrics: ['pageViews', 'purchaseIntentClicks', 'purchaseIntentRate', 'avgTimeSpent'],
      filters: [],
    },
  },
  {
    key: 'Experience Breakdown',
    category: 'Experience',
    value: {
      dimensions: ['experienceNameWithLink'],
      metrics: ['pageViews', 'purchaseIntentClicks', 'purchaseIntentRate', 'avgTimeSpent'],
      filters: [],
    },
  },
  {
    key: 'Handle Breakdown',
    category: 'Handle',
    value: {
      dimensions: ['eventDate', 'handle', 'experienceNameWithLink'],
      metrics: ['pageViews', 'purchaseIntentClicks', 'purchaseIntentRate', 'avgTimeSpent'],
      filters: [],
    },
  },
  {
    key: 'Audiences Breakdown',
    category: 'Audiences',
    value: {
      dimensions: ['audience'],
      metrics: ['pageViews', 'purchaseIntentRate', 'avgTimeSpent'],
      filters: [],
    },
  },
  {
    key: 'Facebook Ad ID & Ad Name Breakdown',
    category: 'Platforms',
    value: {
      dimensions: ['fbigPinAdId', 'fbigPinAdName'],
      metrics: ['pageViews', 'purchaseIntentRate'],
      filters: [
        {
          key: 'platformName',
          operator: 'includes',
          value: ['FB/IG'],
        },
      ],
    },
  },
  {
    key: 'DCM Site ID Breakdown',
    category: 'Platforms',
    value: {
      dimensions: ['dcmSiteId'],
      metrics: ['purchaseIntentClicks', 'purchaseIntentRate', 'avgTimeSpent'],
      filters: [],
    },
  },
  {
    key: 'Discover In-Store Report',
    category: 'Retailers',
    value: {
      dimensions: ['experienceType', 'experienceName'],
      metrics: [
        'storeLocationFocused',
        'storeViewClicked',
        'onlineViewClicked',
      ],
      filters: [
        {
          key: 'experienceType',
          operator: 'includes',
          value: ['Discover Brand.com', 'Discover Media'],
        },
      ],
    },
  },
];
